/**
 * Earn XP Card Component
 * Shows ways to earn XP
 */

import { Scan, Users, Zap, Lightbulb } from 'lucide-react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { XP_VALUES, EARN_XP_COLORS } from '../utils/constants';

export function EarnXpCard() {
  const { t } = useLanguage();

  const earnMethods = [
    {
      icon: Scan,
      colors: EARN_XP_COLORS.scan,
      title: t('profile.earnXp.scanAsIs', 'Scan As-Is Items'),
      description: t('profile.earnXp.scanAsIsDesc', 'Scan products in the As-Is section'),
      xp: `+${XP_VALUES.AS_IS_SCAN} XP`,
    },
    {
      icon: Users,
      colors: EARN_XP_COLORS.refer,
      title: t('profile.earnXp.referFriends', 'Refer Friends'),
      description: t('profile.earnXp.referFriendsDesc', 'Get referrals to join and qualify'),
      xp: `+${XP_VALUES.REFERRAL} XP`,
    },
    {
      icon: Zap,
      colors: EARN_XP_COLORS.share,
      title: t('profile.earnXp.shareDaily', 'Share Daily'),
      description: t('profile.earnXp.shareDailyDesc', 'Share on up to 3 platforms per day'),
      xp: `+${XP_VALUES.SHARE_FIRST}-${XP_VALUES.SHARE_THIRD} XP`,
    },
  ];

  return (
    <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden hover:shadow-lg hover:border-primary-200 transition-all duration-200">
      {/* Header */}
      <div className="px-6 py-4 border-b border-gray-100">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-green-100 rounded-lg">
            <Lightbulb className="w-5 h-5 text-green-600" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-900">
              {t('profile.earnXp.title', 'How to Earn XP')}
            </h2>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="p-6 space-y-4">
        {earnMethods.map((method) => (
          <div
            key={method.title}
            className="flex items-center gap-4 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <div className={`p-2 ${method.colors.bg} rounded-lg`}>
              <method.icon className={`w-5 h-5 ${method.colors.icon}`} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-medium text-gray-900">{method.title}</div>
              <div className="text-sm text-gray-500">{method.description}</div>
            </div>
            <div className="text-lg font-bold text-primary-600 flex-shrink-0">
              {method.xp}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
